import { GoPlus } from "react-icons/go";
import { Button } from "../../../../components/forms";
import { nodept } from "../../../../constant/import";
import useLeaveHook from "../../../../hooks/useLeaveHook";
import PositionItem from "../PositionItem";
import LeaveTypeITem from "./LeaveTypeITem";

export default ({ setshowadddept, leaves, refresh }: any) => {
  const EmptyList = () => (
    <div className=" mx-6 p-5 scale-[.75]   text-textbg flex flex-col justify-center rounded-xl items-center border border-gray-300 ">
      <img src={nodept} />
      <p className="font-bold">No Leave Type</p>
      <small>No leave type has been added</small>

      <Button
        width={200}
        disabled={false}
        text={
          <>
            {" "}
            <GoPlus size={15} className=" mx-1 inline" /> Add Type
          </>
        }
        onBtnClick={() => {
          setshowadddept(true);
        }}
      />
    </div>
  );

  return (
    <div>
     <div className="flex justify-between"> <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
        Types({leaves.length})
      </p>    <Button
            width={200}
            disabled={false}
            text={
              <>
                {" "}
                <GoPlus size={15} className=" mx-1 inline" /> Add Type
              </>
            }
            onBtnClick={() => {
              setshowadddept(true);
            }}
          />
          </div>
      <div>
        {leaves.length > 0 ? (
          leaves.map((it: any) => <LeaveTypeITem refresh ={refresh} item={it} />)
        ) : (
          <EmptyList />
        )}
      </div>
    </div>
  );
};
